var _path, _path2, _circle, _g, _circle2, _g2, _circle3, _g3, _circle4, _g4, _circle5, _g5, _circle6, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBalancedGauge = function SvgBalancedGauge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118,
    height: 91,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#balanced-gauge_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E2D2C",
    d: "M30.075 73.626c1.494.324 2.232 1.584 2.232 2.898 0 2.034-1.638 3.402-4.392 3.402h-6.156v-12.24h5.796c2.664 0 4.212 1.26 4.212 3.258 0 1.134-.63 2.304-1.692 2.682m-2.988-3.456H24.8v2.556h2.286c1.152 0 1.782-.576 1.782-1.368 0-.774-.612-1.188-1.782-1.188m.432 7.236c1.26 0 1.818-.558 1.818-1.278 0-.756-.63-1.188-1.764-1.188H24.8v2.466zm12.527-6.21h2.916v8.73h-2.916v-.468c-.648.432-1.422.702-2.394.702-2.358 0-4.338-2.016-4.338-4.608 0-2.61 1.98-4.59 4.338-4.59.972 0 1.746.252 2.394.684zm-1.8 6.48c.63 0 1.242-.162 1.8-.774v-2.7c-.558-.612-1.17-.774-1.8-.774-1.188 0-2.07.918-2.07 2.124s.882 2.124 2.07 2.124m6.696-10.53h2.934v12.78h-2.934zm11.188 4.05h2.916v8.73H56.13v-.468c-.648.432-1.422.702-2.394.702-2.358 0-4.338-2.016-4.338-4.608 0-2.61 1.98-4.59 4.338-4.59.972 0 1.746.252 2.394.684zm-1.8 6.48c.63 0 1.242-.162 1.8-.774v-2.7c-.558-.612-1.17-.774-1.8-.774-1.188 0-2.07.918-2.07 2.124s.882 2.124 2.07 2.124m12.024-6.714c2.196 0 3.708 1.494 3.708 3.978v4.986h-2.916v-4.518c0-1.242-.63-1.8-1.602-1.8-.522 0-1.08.27-1.584.828v5.49h-2.934v-8.73h2.934v.576c.702-.522 1.458-.81 2.394-.81m9.98 6.732c.882 0 1.566-.558 1.71-1.35h2.754c-.216 2.25-2.07 3.816-4.482 3.816-2.736 0-4.77-1.944-4.77-4.608 0-2.646 2.034-4.59 4.77-4.59 2.412 0 4.266 1.566 4.482 3.816h-2.754c-.144-.792-.828-1.35-1.71-1.35-1.26 0-1.998.936-1.998 2.124s.738 2.142 1.998 2.142m10.208-6.732c3.078 0 4.932 2.196 4.5 5.292h-6.318c.198.9.792 1.602 1.98 1.602.648 0 1.026-.144 1.296-.468h2.952c-.522 1.71-2.142 2.772-4.194 2.772-2.862 0-4.77-1.944-4.77-4.608 0-2.646 1.854-4.59 4.554-4.59m.072 2.16c-1.026 0-1.62.576-1.854 1.458h3.636c-.162-1.008-.792-1.458-1.782-1.458m12.424-5.976h2.916v12.78h-2.916v-.432c-.648.414-1.422.666-2.394.666-2.358 0-4.338-1.98-4.338-4.59 0-2.592 1.98-4.572 4.338-4.572.972 0 1.746.252 2.394.684zm-1.8 10.566c.63 0 1.242-.162 1.8-.774v-2.7c-.558-.612-1.17-.774-1.8-.774-1.188 0-2.07.918-2.07 2.106 0 1.224.882 2.142 2.07 2.142"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "balanced-gauge_svg__b",
    width: 118,
    height: 58,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.645.758h116.38v57.151H.645z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#balanced-gauge_svg__b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "balanced-gauge_svg__c",
    width: 118,
    height: 117,
    x: 0,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.834,
    cy: 59.538,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#balanced-gauge_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFA8B8",
    stroke: "#FFA8B8",
    d: "m53.76 53.727 3.41-1.2L40.244 2.97l-18.338 8.976-10.633 13.9z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "balanced-gauge_svg__d",
    width: 118,
    height: 117,
    x: 0,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.834,
    cy: 59.538,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#balanced-gauge_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FD8FA4",
    stroke: "#FD8FA4",
    d: "M57.12 50.618 40.226.642l18.402-4.253L77.71.2l-16.43 50.67z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "balanced-gauge_svg__e",
    width: 118,
    height: 117,
    x: 0,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.834,
    cy: 59.538,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#balanced-gauge_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D93657",
    stroke: "#D93657",
    d: "M106.952 23.573 68.34 49.948l3.868 7.525h46.347l-3.586-20.677z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "balanced-gauge_svg__f",
    width: 118,
    height: 117,
    x: 0,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.834,
    cy: 59.538,
    r: 57.69,
    fill: "#D9D9D9",
    stroke: "#FDEFE0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#balanced-gauge_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE1E7",
    stroke: "#FFE1E7",
    d: "m10.716 23.573 38.612 26.375-3.868 7.525H-.887l3.586-20.677z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "balanced-gauge_svg__g",
    width: 118,
    height: 117,
    x: 0,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.834,
    cy: 59.538,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#balanced-gauge_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FC6481",
    stroke: "#FC6481",
    d: "m65.199 52.323-3.43-1.142L77.872 1.349l18.484 8.67 10.862 13.722z"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.833,
    cy: 59.545,
    r: 26.263,
    fill: "#fff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "m55.416 42.347 3.907-3.724 3.81 3.998M59.114 56.619l.19-16.499"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "balanced-gauge_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .758h118v90H0z"
  })))));
};
export { SvgBalancedGauge as ReactComponent };
export default __webpack_public_path__ + "images/balanced-gauge.svg";